import axios from "axios";

const _axios = axios.create();

const AxiostRequest = async (payload) => {
  const token = localStorage.getItem("token");
  const masterCustomerId = localStorage.getItem("masterCustomerId");
  const activeBusinessId = localStorage.getItem("activeBusinessId");

  const config = {
    headers: {
      "Content-Type": "application/json",
      "x-master-customer-id": masterCustomerId || "",
      "x-business-id": activeBusinessId || "",
      ...payload.headers,
    },
    method: payload.method,
    url: payload.url,
    data: payload.data,
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  try {
    const response = await _axios(config);
    return response;
  } catch (err) {
    if (err.response?.status === 401 && !payload.url.includes('/login')) {
      console.error("Session expired or unauthorized.");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    throw err;
  }
};

const AxiosService = {
  AxiostRequest,
};

export default AxiosService;
